/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActiveEmployeeRegistrationViewModel } from '../../models/active-employee-registration-view-model';

export interface GetActiveLogin$Params {
  workCenterId: number;
}

export function getActiveLogin(http: HttpClient, rootUrl: string, params: GetActiveLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<ActiveEmployeeRegistrationViewModel>> {
  const rb = new RequestBuilder(rootUrl, getActiveLogin.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ActiveEmployeeRegistrationViewModel>;
    })
  );
}

getActiveLogin.PATH = '/api/v1/{workCenterId}/GetActiveLogin';
